import {Store, _} from 'utils';
import {JobStore} from 'model';

class ApplyStore extends Store {

	getInitialState()
	{
		return {
			loading: false,
			showApplySuccess: false,
			documentSure: false,
			firstName: '',
			lastName: '',
			phone: '',
			email: '',
			password: '',
			fileName: null,
			fileContent: null,
			attachProfile: 0,
			emailError: false,
			passwordError: false,
			firstNameError: false,
			lastNameError: false,
			phoneError: false,
			applyError: '',
		}
	}

	onFastApplyFieldChanged(state, data)
	{
		state[data.name] = data.value;
		state[data.name + 'Error'] = false;
	}

	onFastApplyDocumentUploaded(state, data)
	{
		if (data.value['name'] && data.value['content'])
		{
			state['fileName'] = data.value['name'];
			state['fileContent'] = data.value['content'];
			state['documentSure'] = false;
		}
	}

	onFastApplyDataCleared(state)
	{
		var initialState = this.getInitialState();
		Object.keys(initialState).forEach(function (stateKey)
		{
			state[stateKey] = initialState[stateKey];
		});
	};

	onFastAppliedSuccess(state, data)
	{
		console.log(data);

		var initState = this.getInitialState();
		initState.showApplySuccess = true;

		Object.keys(initState).map(function (key, index)
		{
			state[key] = initState[key];
		});
	}

	onFastAppliedError(state, data)
	{
		console.error(data);
		state.applyError = _('Fast apply error');
		if (data.code === 401)
		{
			state.emailError = true;
			state.passwordError = true;
		}
		else
		{
			state.emailError = false;
			state.passwordError = false;
		}
	}

	onFastApplyLoadingChanged(state, data)
	{
		state.loading = data.loading;
	}

	getUserPass()
	{
		var state = this.getState();
		return {
			email: state.email,
			password: state.password
		};
	}

	getApplicationAnonData()
	{
		var state = this.getState();
		return {
			jobIds: JobStore.getSelectedJobs(),
			firstName: state.firstName,
			lastName: state.lastName,
			phone: state.phone,
			email: state.email,
			fileName: state.fileName,
			fileContent: btoa(state.fileContent)
		};
	}

	getApplicationData()
	{
		var state = this.getState();
		return {
			jobIds: JobStore.getSelectedJobs(),
			email: state.email,
			password: state.password,
			fileName: state.fileName,
			fileContent: btoa(state.fileContent),
			attachProfile: state.attachProfile
		};
	}

}

const store = new ApplyStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/applystore.js